<template>
  <b-container>
    <div class="mt-5 pl-4 pr-4 pb-4 bg-white">
      <br>
      <h1><strong>About Us</strong></h1>
      <br>
      <p style="text-align: justify">The CultureLabs platform is being developed as part of the project CultureLabs that
        has received funding from the European Union’s Horizon 2020 Research and Innovation programme under Grant
        Agreement No 770158.</p>
      <p style="text-align: justify">Cultural Heritage is an excellent way to promote social inclusion and community
        empowerment. Working collaboratively across six countries (Greece, Italy, Spain, Finland, UK and Germany), the
        CultureLabs project aims to support participation in culture and create opportunities of collaboration between
        communities - especially those at risk of marginalisation - cultural heritage institutions (such as museums,
        libraries, and galleries), civil society organisations and public administrations.
        The CultureLabs project is conducting in-depth needs analysis of the practices of cultural heritage
        institutions, civil society organisations and public administrations as well as of the community (particularly
        migrants and/or refugees). It is investigating the role of technology as a facilitator and mediator of
        participatory approaches in the fields of Cultural Heritage and social innovation by developing and testing an
        ICT platform that facilitates the organisation of participatory projects and the reuse of good ideas
        and practices in new contexts. It is also carrying out a comparative review of participatory approaches, with
        emphasis on those focusing on social inclusion and intercultural dialogue.
      </p>
      <p style="text-align: justify">The CultureLabs project counts on the collaboration of a broad and heterogeneous
        European partnership that merges <strong>interdisciplinary</strong> and <strong>specific expertise</strong>. The
        consortium includes the following partners:</p>
      <ul class="pl-4">
        <li style="text-align: justify">
          <p style="text-align: justify"><strong>Institute of Communication and Computer Systems</strong> of the School
            of
            Electrical and Computer Engineering (ECE) of
            the National Technical University of Athens (NTUA) is expert in the aggregation, management, and creative
            reuse
            of digital Cultural Heritage.</p>
        </li>
        <li style="text-align: justify">
          <p style="text-align: justify"><strong>SingularLogic S.A.</strong> is the leading Software and Integrated IT
            Solutions Group in Greece, offering advanced,
            integrated IT systems and delivering technological solutions, services and innovation in a wide variety of
            application fields.
          </p>
        </li>
        <li style="text-align: justify">
          <p style="text-align: justify"><strong>Sheffield Hallam University</strong> is expert in participatory design
            and
            co-creation particularly in the context of Cultural Heritage.
          </p>
        </li>
        <li style="text-align: justify">
          <p style="text-align: justify"><strong>People's History Museum</strong> is the national museum of democracy,
            telling the story of its development in Britain: past, present, and future.
          </p>
        </li>
        <li style="text-align: justify">
          <p style="text-align: justify"><strong>Museovirasto – Finnish Heritage Agency</strong> works to promote the
            conservation, sustainable use and greater recognition of cultural heritage.
          </p>
        </li>
        <li style="text-align: justify">
          <p style="text-align: justify"><strong>Fondazione Sistema Toscana</strong> is a non-profit foundation created
            by
            the Tuscany Region with the aim to promote the Tuscan territorial system through integrated multimedia
            communication tools.
          </p>
        </li>
        <li style="text-align: justify">
          <p style="text-align: justify"><strong>COOSS</strong> is a non-profit organization providing social services
            to
            disadvantaged people in Marche Region.
          </p>
        </li>
        <li style="text-align: justify">
          <p style="text-align: justify"><strong>Platoniq</strong> is an international non-profit organization involved
            in emerging models and economic sustainability practices around commons.
          </p>
        </li>
        <li style="text-align: justify">
          <p style="text-align: justify"><strong>Europäisches Forum für
            Migrationsstudien</strong> which was a research institute studying the causes, consequences and broader
            implications of migration.
          </p>
        </li>
      </ul>

    </div>
  </b-container>
</template>

<script>
export default {
  name: 'AboutUs.vue'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AboutUs.vue